(function () {
  function initProductCarouselTabs(sectionId) {
    var sectionEl = document.getElementById(
      'section-' + sectionId
    );

    if (!sectionEl || typeof Swiper === 'undefined') {
      return;
    }

    var desktopSlidesPerView =
      parseInt(
        sectionEl.getAttribute('data-slides-per-view'),
        10
      ) || 4;

    var mobileSlidesPerView =
      parseInt(
        sectionEl.getAttribute(
          'data-mobile-slides-per-view'
        ),
        10
      ) || 2;

    var tabBtns = Array.from(
      sectionEl.querySelectorAll('.pct-tab-btn')
    );

    var panels = Array.from(
      sectionEl.querySelectorAll('.pct-panel')
    );

    var prevBtn = sectionEl.querySelector(
      '.pct-arrow--prev'
    );

    var nextBtn = sectionEl.querySelector(
      '.pct-arrow--next'
    );

    var swipers = {};
    var activeIdx = 0;

    function buildSwiper(idx) {
      if (swipers[idx]) {
        swipers[idx].destroy(true, true);
        delete swipers[idx];
      }

      var swiperEl = document.getElementById(
        'pct-swiper-' + sectionId + '-' + idx
      );

      var paginationEl = document.getElementById(
        'pct-pagination-' + sectionId + '-' + idx
      );

      if (!swiperEl) {
        return;
      }

      swipers[idx] = new Swiper(swiperEl, {
        slidesPerView: mobileSlidesPerView,
        slidesPerGroup: mobileSlidesPerView,
        spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,

        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn
        },

        pagination: {
          el: paginationEl,
          clickable: true,
          dynamicBullets: false
        },

        breakpoints: {
          750: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 24
          },

          990: {
            slidesPerView: desktopSlidesPerView,
            slidesPerGroup: desktopSlidesPerView,
            spaceBetween: 30
          }
        }
      });
    }

    function setActiveTab(idx) {
      tabBtns.forEach(function (btn, buttonIdx) {
        var isActive = buttonIdx === idx;

        btn.classList.toggle(
          'active',
          isActive
        );

        btn.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );

        btn.setAttribute(
          'tabindex',
          isActive ? '0' : '-1'
        );
      });
    }

    function switchTab(idx) {
      if (
        idx < 0 ||
        idx >= tabBtns.length ||
        !panels[idx]
      ) {
        return;
      }

      setActiveTab(idx);

      var previousIdx = activeIdx;
      var outgoingPanel = panels[previousIdx];
      var incomingPanel = panels[idx];

      activeIdx = idx;

      if (
        previousIdx === idx ||
        !outgoingPanel ||
        outgoingPanel === incomingPanel
      ) {
        incomingPanel.hidden = false;
        incomingPanel.classList.add('active');
        buildSwiper(idx);
        return;
      }

      outgoingPanel.style.opacity = '0';
      outgoingPanel.style.transform =
        'translateY(6px)';
      outgoingPanel.style.pointerEvents = 'none';

      window.setTimeout(function () {
        outgoingPanel.classList.remove('active');
        outgoingPanel.hidden = true;
        outgoingPanel.style.opacity = '';
        outgoingPanel.style.transform = '';
        outgoingPanel.style.pointerEvents = '';

        incomingPanel.hidden = false;
        incomingPanel.style.opacity = '0';
        incomingPanel.style.transform =
          'translateY(10px)';
        incomingPanel.classList.add('active');

        buildSwiper(idx);

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            incomingPanel.style.transition =
              'opacity 0.35s ease, transform 0.35s ease';

            incomingPanel.style.opacity = '1';
            incomingPanel.style.transform =
              'translateY(0)';

            window.setTimeout(function () {
              incomingPanel.style.opacity = '';
              incomingPanel.style.transform = '';
              incomingPanel.style.transition = '';
            }, 360);
          });
        });
      }, 300);
    }

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(
          this.getAttribute('data-tab-index'),
          10
        );

        switchTab(idx);
      });

      btn.addEventListener(
        'keydown',
        function (event) {
          var currentIdx = parseInt(
            this.getAttribute('data-tab-index'),
            10
          );

          var newIdx = currentIdx;

          if (event.key === 'ArrowRight') {
            newIdx =
              (currentIdx + 1) % tabBtns.length;
          } else if (event.key === 'ArrowLeft') {
            newIdx =
              (currentIdx - 1 + tabBtns.length) %
              tabBtns.length;
          } else if (event.key === 'Home') {
            newIdx = 0;
          } else if (event.key === 'End') {
            newIdx = tabBtns.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          switchTab(newIdx);
          tabBtns[newIdx].focus();
        }
      );
    });

    if (tabBtns.length > 0) {
      switchTab(0);
    }
  }

  function getSectionIds() {
    return Array.from(
      document.querySelectorAll(
        '.product-carousel-tabs[data-section-id]'
      )
    ).map(function (element) {
      return element.getAttribute(
        'data-section-id'
      );
    });
  }

  function initializeSections() {
    var sectionIds = getSectionIds();

    if (!sectionIds.length) {
      return;
    }

    function run() {
      sectionIds.forEach(function (sectionId) {
        initProductCarouselTabs(sectionId);
      });
    }

    if (typeof Swiper !== 'undefined') {
      run();
    } else {
      document.addEventListener(
        'swiper:ready',
        run,
        { once: true }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeSections
    );
  } else {
    initializeSections();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      var sectionEl = event.target.querySelector(
        '.product-carousel-tabs[data-section-id]'
      );

      if (!sectionEl) {
        return;
      }

      var sectionId =
        sectionEl.getAttribute('data-section-id');

      if (typeof Swiper !== 'undefined') {
        initProductCarouselTabs(sectionId);
      } else {
        document.addEventListener(
          'swiper:ready',
          function () {
            initProductCarouselTabs(sectionId);
          },
          { once: true }
        );
      }
    }
  );
})();
